module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0143.jpg?v=f58b6669";